import { ColorProps, Flex, Text, useTheme } from '@homebotapp/hb-react-component-catalog'
import trendDown from '../../../assets/homes/img/trendDown.svg'
import trendUp from '../../../assets/homes/img/trendUp.svg'
import { useMemo } from 'react'
import { Listing, ListingCompact } from '../../../api/gqlaxy/gql/generated/graphql'
import { defineMessages, useIntl } from 'react-intl'
import { formatAbbrCurrency } from '../../../helpers/formatters'

export interface ListingPriceChangeTagProps {
  listing: ListingCompact | Listing
}

const MSG = defineMessages({
  priceDrop: {
    id: 'HomeSearch.listingCard.priceDrop',
    defaultMessage: 'Price drop: {priceChange}'
  }
})

export const ListingPriceChangeTag = ({
  listing: { previousListPriceCents, priceCents }
}: ListingPriceChangeTagProps) => {
  const hasPriceChanged = useMemo(() => previousListPriceCents !== priceCents, [previousListPriceCents, priceCents])
  const priceChange = useMemo(() => priceCents - previousListPriceCents, [previousListPriceCents, priceCents])
  const { theme } = useTheme()
  const intl = useIntl()

  const status = useMemo(() => {
    return {
      borderColor:
        previousListPriceCents > priceCents
          ? `success.${theme.isLightThemeType ? 400 : 700}`
          : `yellow.${theme.isLightThemeType ? 400 : 700}`,
      bgColor:
        previousListPriceCents > priceCents
          ? `success.${theme.isLightThemeType ? 200 : 900}`
          : `yellow.${theme.isLightThemeType ? 200 : 900}`,
      color:
        previousListPriceCents > priceCents
          ? `success.${theme.isLightThemeType ? 900 : 50}`
          : `yellow.${theme.isLightThemeType ? 900 : 50}`,
      icon: previousListPriceCents > priceCents ? trendDown : trendUp
    }
  }, [hasPriceChanged, priceChange])

  return hasPriceChanged && priceChange < 0 ? (
    <Flex
      alignItems='center'
      justifyItems='center'
      borderWidth={1}
      borderRadius={12}
      borderColor={status.borderColor}
      backgroundColor={status.bgColor as ColorProps['backgroundColor']}
      px={2}
      py={0.5}
    >
      <Text m={0} fontWeight={600} size='3xs' color={theme.isLightThemeType ? 'success.900' : 'success.50'}>
        {intl.formatMessage(MSG.priceDrop, {
          priceChange: formatAbbrCurrency(Math.abs(priceChange) / 100)
        })}
      </Text>
    </Flex>
  ) : null
}
